"use client"

import React from 'react'
import { GoHeart, GoHeartFill } from 'react-icons/go';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@/Components/ui/tooltip"
import { useProductFavourite } from '@/hooks/useFavourite';

const ProductLike = ({ product }) => {
	const { isFavourite, toggleFavourite } = useProductFavourite();
	const isSelected = isFavourite(product._id || product.id, product.productFamilyIds);

	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<span
						onClick={(e) => toggleFavourite(e, product)}
						className="h-8 w-8 shrink-0 rounded-lg border border-[#F64C4C]/30 bg-[#F64C4C]/10 flex items-center justify-center cursor-pointer transition-colors hover:bg-[#F64C4C]/15"
					>
						{isSelected ? (
							<GoHeartFill color="#F64C4C" />
						) : (
							<GoHeart color="#F64C4C" />
						)}
					</span>
				</TooltipTrigger>
				<TooltipContent>
					<p className="text-xs font-medium">
						{isSelected ? "Unfavorite the product" : "Favorite the product"}
					</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	)
}

export default ProductLike
